import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "submitBtn", "count"];

  connect() {
    this.updateCount();
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked;
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked;
    });
    this.updateCount();
  }

  updateCount() {
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length;
    const allChecked =
      checkedCount === this.checkboxTargets.length && checkedCount > 0;

    this.selectAllTarget.checked = allChecked;
    this.selectAllTarget.indeterminate = checkedCount > 0 && !allChecked;

    this.submitBtnTargets.forEach((btn) => {
      btn.disabled = checkedCount === 0;
    });

    if (this.hasCountTarget) {
      this.countTarget.textContent = checkedCount;
    }
  }

  submitTo(event) {
    event.preventDefault();
    const customUrl = event.currentTarget.dataset.bulkSelectUrl;

    if (customUrl) {
      // For custom URLs, create a new form with the selected values and CSRF token
      const form = document.createElement("form");
      form.method = "POST";
      form.action = customUrl;

      // Add CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
      if (csrfToken) {
        const csrfInput = document.createElement("input");
        csrfInput.type = "hidden";
        csrfInput.name = "authenticity_token";
        csrfInput.value = csrfToken;
        form.appendChild(csrfInput);
      }

      // Add selected checkbox values
      this.checkboxTargets
        .filter((cb) => cb.checked)
        .forEach((cb) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = cb.name;
          input.value = cb.value;
          form.appendChild(input);
        });

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } else {
      this.element.requestSubmit();
    }
  }
}
